import { useEffect, useState } from "react";

const POSITIONS = {
  "top-right": { top: "60px", left: "calc(100% - 40px)" },
  "bottom-left": { top: "calc(100% - 95px)", left: "10px" },
  "top-left": { top: "10px", left: "10px" },
  "bottom-right": { top: "calc(100% - 40px)", left: "calc(100% - 40px)" },
};

const Bola = ({ position, numVoltas = 3 }) => {
  const [style, setStyle] = useState(POSITIONS[position] || {});
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (POSITIONS[position]) {
      setStyle(POSITIONS[position]);
      // Incrementa rotação com base no número de voltas desejado
      setRotation((prev) => prev + 360 * numVoltas);
    }
  }, [position, numVoltas]);

  return (
    <div
      className="absolute transition-all duration-1000 ease-in-out"
      style={{
        ...style,
      }}
    >
      <div
        style={{
          transform: `rotate(${rotation}deg)`,
          transition: "transform 1s ease-in-out",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23pt"
          height="23pt"
          viewBox="0 0 1026 1026"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0,1046) scale(0.1,-0.1)"
            fill="#0000ff"
            stroke="none"
          >
            <circle cx="5100" cy="5150" r="4500" fill="#FFEB3B" />

            <path
              d="M4800 9780 c-58 -5 -139 -14 -180 -20 -41 -6 -122 -17 -180 -25 -126
-18 -357 -62 -440 -84 -138 -37 -196 -53 -228 -65 -20 -7 -55 -19 -77 -25 -22
-7 -49 -16 -60 -21 -18 -7 -75 -29 -225 -85 -25 -9 -58 -23 -75 -30 -16 -7
-50 -21 -75 -31 -70 -29 -397 -196 -475 -244 -209 -128 -446 -294 -622 -438
-173 -141 -590 -581 -704 -742 -13 -19 -29 -40 -36 -48 -22 -24 -221 -328
-274 -418 -131 -225 -284 -556 -361 -779 -5 -16 -14 -39 -18 -50 -60 -143
-179 -639 -200 -838 -6 -56 -15 -124 -21 -152 -36 -190 -36 -810 0 -1000 5
-27 17 -104 25 -170 27 -213 84 -476 142 -654 13 -42 29 -92 35 -111 48 -155
167 -445 261 -635 142 -291 388 -665 598 -909 155 -182 394 -419 544 -541 27
-22 79 -65 115 -95 36 -30 95 -75 131 -100 37 -25 98 -66 136 -93 94 -65 223
-147 230 -147 3 0 18 -8 32 -19 49 -34 285 -158 402 -210 63 -28 123 -56 132
-61 10 -6 22 -10 28 -10 6 0 29 -9 53 -19 43 -19 259 -102 332 -126 22 -8 67
-19 100 -26 33 -6 69 -15 80 -19 11 -5 31 -11 45 -14 14 -2 43 -10 65 -16 98
-26 321 -67 470 -85 66 -8 158 -21 205 -27 115 -17 681 -17 815 0 275 34 338
43 440 62 61 11 128 24 150 29 22 5 56 12 75 16 79 16 513 151 575 180 17 7
55 23 85 35 52 20 68 27 150 63 341 149 702 372 1040 643 160 128 456 420 590
584 25 30 59 70 76 90 79 90 374 520 374 546 0 2 14 27 31 56 141 237 247 467
341 738 21 63 46 133 53 155 29 84 109 393 124 480 7 39 17 86 22 105 31 117
67 551 68 805 1 295 -44 723 -99 955 -6 25 -15 65 -20 90 -5 25 -18 79 -30
120 -11 41 -27 98 -35 125 -37 133 -123 370 -206 565 -70 164 -245 494 -316
595 -24 34 -58 84 -75 112 -167 263 -444 583 -743 857 -106 97 -145 130 -245
209 -58 46 -283 203 -380 265 -187 119 -510 288 -675 352 -60 23 -119 46 -130
50 -64 26 -139 52 -200 71 -38 11 -90 28 -115 36 -25 8 -69 21 -97 29 -29 8
-79 21 -110 29 -60 16 -72 19 -238 55 -89 19 -218 38 -480 70 -111 14 -598 20
-725 10z m530 -74 c353 -15 612 -54 965 -147 49 -13 458 -148 539 -178 190
-71 540 -260 806 -436 272 -180 425 -308 710 -594 187 -188 424 -470 407 -487
-2 -3 -44 22 -93 54 -172 114 -293 172 -509 243 -173 58 -255 69 -532 70 -292
1 -347 -8 -581 -101 -216 -84 -468 -260 -699 -486 -106 -104 -159 -165 -293
-336 -112 -143 -433 -442 -594 -554 -17 -11 -62 -42 -99 -68 -129 -88 -598
-335 -807 -423 -103 -44 -301 -114 -370 -132 -19 -5 -62 -17 -95 -26 -111 -30
-240 -54 -375 -70 -160 -19 -843 -34 -853 -18 -6 9 -58 249 -77 353 -5 25 -25
113 -45 195 -199 821 -398 1295 -638 1521 -93 87 -161 122 -255 131 -44 4 -62
10 -60 19 4 16 260 276 350 355 73 64 173 148 204 169 12 8 83 59 157 113 232
166 535 341 757 437 41 18 93 40 115 50 97 43 306 118 470 169 230 70 506 125
750 150 61 7 124 14 140 17 39 6 387 20 445 17 25 -2 97 -5 160 -7z m3828
-3217 c74 -25 133 -57 184 -102 39 -34 168 -220 168 -242 0 -7 13 -42 29 -78
93 -207 135 -871 85 -1327 -26 -237 -66 -483 -93 -580 -6 -19 -20 -73 -31
-120 -43 -168 -117 -387 -215 -635 -49 -123 -226 -458 -338 -640 -44 -72 -190
-283 -241 -349 -105 -136 -258 -305 -428 -472 -187 -185 -269 -257 -423 -370
-105 -78 -410 -284 -419 -284 -2 0 -60 -32 -128 -71 -67 -39 -148 -83 -178
-96 -30 -14 -97 -45 -148 -69 -52 -24 -97 -44 -102 -44 -4 0 -36 -13 -71 -29
-35 -16 -120 -48 -189 -71 -69 -22 -134 -45 -145 -50 -111 -46 -489 -133 -638
-147 -67 -6 -80 -1 -318 117 -737 367 -1253 777 -1570 1247 -93 139 -207 383
-253 543 -133 467 -101 932 101 1490 44 121 61 161 125 300 17 36 34 76 39 89
9 23 13 24 77 18 59 -5 225 -21 607 -58 185 -18 680 -15 820 4 379 54 817 158
1075 255 134 51 214 93 492 258 226 135 414 280 574 445 131 136 356 383 395
434 57 73 273 317 319 358 64 57 194 144 285 190 85 42 242 97 310 108 70 11
169 2 243 -22z m-8201 -381 c238 -112 483 -378 805 -878 81 -126 204 -335 276
-470 19 -36 55 -103 80 -150 52 -96 232 -458 232 -466 0 -3 -24 -45 -54 -93
-206 -333 -332 -691 -355 -1006 -26 -361 49 -674 237 -990 165 -277 445 -569
785 -819 43 -32 76 -60 73 -63 -5 -5 -94 42 -213 114 -40 24 -75 43 -77 43
-19 0 -336 216 -440 300 -147 119 -447 406 -586 560 -249 277 -533 707 -693
1050 -152 326 -284 718 -342 1015 -81 413 -113 856 -86 1210 7 83 12 157 12
165 0 8 7 60 14 115 8 55 19 142 26 193 17 128 39 195 70 204 51 15 166 -1
236 -34z"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Bola;
